import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("customer") !== null && localStorage.getItem("customer") !== undefined && localStorage.getItem("customer") !== "") {

    data = JSON.parse(localStorage.getItem("customer"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getcustomer: (state, action) => {
            localStorage.setItem("customer", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const { getcustomer } = Insider.actions;
export default Insider.reducer;